import './forgotPassword.scss'
import templateUrl from './forgotPassword.html'
import logo from 'tmrAssets/images/logo-big.png'

/**
 * Reset password route.
 *
 * @namespace routes.ForgotPassword
 * @type {TmrRoute}
 */
export const route = {
  name: 'forgotPassword',
  label: 'FORGOTPASSWORD.TITLE',
  url: '/reset-password',
  component: 'tmrForgotPassword',
  accessControl: [],
  accessAnonymous: true,
}

/**
 * Reset password component.
 *
 * @type {ngComponent}
 */
export const tmrForgotPassword = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrForgotPasswordController',
}

/**
 * Controller of component {@link tmrForgotPassword}
 *
 * @type {ngController}
 */
export class tmrForgotPasswordController {
  static ngType = 'controller'

  constructor($state, TmrApiAuth, TmrToast) {
    'ngInject'
    Object.assign(this, { $state, TmrApiAuth, TmrToast, logo })
  }

  /** Sends reset password request */
  onSubmit() {
    this.error = false
    return this.TmrApiAuth.resetPassword(this.username).then(
      () => (this.sent = true),
      err => {
        this.error = true
        throw err
      }
    )
  }

  /** Redirects to temporary login page */
  submitToken(token) {
    this.$state.go('app.temporaryLogin', { token })
  }
}
